'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isWithin = require('../is-within');

var _isWithin2 = _interopRequireDefault(_isWithin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (frame) {
  var isWithinVertical = (0, _isWithin2.default)(frame.top, frame.bottom);
  var isWithinHorizontal = (0, _isWithin2.default)(frame.left, frame.right);

  return function (point) {
    return isWithinVertical(point.y) && isWithinVertical(point.y) && isWithinHorizontal(point.x) && isWithinHorizontal(point.x);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/state/visibility/is-position-in-frame.js
// module id = 3250
// module chunks = 0